module.exports = __webpack_public_path__ + "static/media/bg-event-mobi.9bdd29f3.png";